import React, { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { getDeviceCoordinates } from "../../utils";
import { defaultValues } from "../../utils/constants";

const AppContext = createContext();

export default function useAppContext() {
  return useContext(AppContext);
}

export const initialState = {
  snackbar: { open: false },
  deviceLocation: {
    lat: null,
    lng: null,
  },
  abhaTxnId: "",
  selectedLocation: {
    coordinates: { lat: null, lng: null },
    place: { name: "Error", address: "Unable to fetch address" },
  },
};

export const AppContextProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState(initialState.snackbar);
  const [deviceLocation, setDeviceLocation] = useState(
    initialState.deviceLocation
  );
  const [abhaTxnId, setAbhaTxnId] = useState(initialState.abhaTxnId);
  const [selectedLocation, setSelectedLocation] = useState(
    initialState.selectedLocation
  );
  const [tempSelectedLocation, setTempSelectedLocation] = useState(
    initialState.selectedLocation
  );
  // console.log("1", selectedLocation, "2", tempSelectedLocation);

  // Best-effort auto-detect on app load. Failing here is NOT an error the
  // user did anything about (permission not granted yet, http dev origin,
  // no GPS fix) — the Home header already prompts "Update your location"
  // with a button, so stay quiet instead of opening a red toast on every
  // visit. Explicit "use my location" taps (SearchPage) do report the reason.
  async function onComponentLoad() {
    const res = await getDeviceCoordinates();
    if (res?.success) {
      setDeviceLocation(res?.coordinates);
    } else if (res?.code) {
      console.info(`Location auto-detect skipped: ${res.code}`);
    }
  }

  function openSnackbar(snackbarProps) {
    setSnackbar({
      ...defaultValues.snackbar,
      ...snackbarProps,
    });
  }

  useEffect(() => {
    onComponentLoad();
  }, []);

  const value = {
    snackbar,
    openSnackbar,
    setSnackbar,
    deviceLocation,
    abhaTxnId,
    setAbhaTxnId,
    selectedLocation,
    setSelectedLocation,
    tempSelectedLocation,
    setTempSelectedLocation,
  };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
